import SerializeDescription from '@/components/serialize-description/SerializeDescription';
import React from 'react';
import { RichTextProps } from '@/components/rich-text/types';

export const RichText: React.FC<RichTextProps> = ({ content }) => {
  return (
    <div className="rich-text-element single-content w-full">
      <div className="container mx-auto grid grid-cols-12 gap-6 px-4 sm:px-0">
        <div className="single-content col-start-1 col-end-13 flex flex-col gap-6 lg:col-start-2 lg:col-end-12 xl:col-start-3 xl:col-end-11">
          <SerializeDescription description={content} />
        </div>
      </div>
    </div>
  );
};
